import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconIgnoreOutliers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.53033 3.46967C8.82322 3.76256 8.82322 4.23744 8.53033 4.53033L7.06066 6L8.53033 7.46967C8.82322 7.76256 8.82322 8.23744 8.53033 8.53033C8.23744 8.82322 7.76256 8.82322 7.46967 8.53033L6 7.06066L4.53033 8.53033C4.23744 8.82322 3.76256 8.82322 3.46967 8.53033C3.17678 8.23744 3.17678 7.76256 3.46967 7.46967L4.93934 6L3.46967 4.53033C3.17678 4.23744 3.17678 3.76256 3.46967 3.46967C3.76256 3.17678 4.23744 3.17678 4.53033 3.46967L6 4.93934L7.46967 3.46967C7.76256 3.17678 8.23744 3.17678 8.53033 3.46967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.25 9C16.25 7.48122 17.4812 6.25 19 6.25C20.5188 6.25 21.75 7.48122 21.75 9C21.75 10.5188 20.5188 11.75 19 11.75C17.4812 11.75 16.25 10.5188 16.25 9ZM19 7.75C18.3096 7.75 17.75 8.30965 17.75 9C17.75 9.69036 18.3096 10.25 19 10.25C19.6904 10.25 20.25 9.69036 20.25 9C20.25 8.30964 19.6904 7.75 19 7.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.25 14C11.25 12.4812 12.4812 11.25 14 11.25C15.5188 11.25 16.75 12.4812 16.75 14C16.75 15.5188 15.5188 16.75 14 16.75C12.4812 16.75 11.25 15.5188 11.25 14ZM14 12.75C13.3096 12.75 12.75 13.3096 12.75 14C12.75 14.6904 13.3096 15.25 14 15.25C14.6904 15.25 15.25 14.6904 15.25 14C15.25 13.3096 14.6904 12.75 14 12.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 16.25C7.48122 16.25 6.25 17.4812 6.25 19C6.25 20.5188 7.48122 21.75 9 21.75C10.5188 21.75 11.75 20.5188 11.75 19C11.75 17.4812 10.5188 16.25 9 16.25ZM7.75 19C7.75 18.3096 8.30965 17.75 9 17.75C9.69036 17.75 10.25 18.3096 10.25 19C10.25 19.6904 9.69036 20.25 9 20.25C8.30964 20.25 7.75 19.6904 7.75 19Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconIgnoreOutliers as ReactComponent };
